import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TResetNewsList, EResetNewsListActionType } from './types';

export const resetNewsList: () => TResetNewsList = actionGenerator<EResetNewsListActionType.Reset>(
  EResetNewsListActionType.Reset,
);
